module.exports = __webpack_public_path__ + "static/media/zrteam.f1ba11fa.jpg";